import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';

import './ShareableLinkNotifications.styles.scss';

type ShareableLinkNotificationsProps = {
  className?: string;
};

const ShareableLinkNotifications: React.FC<ShareableLinkNotificationsProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-notifications', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="title">{t('notifications')}</p>
      <p>{t('appliesToDrAdmins')}</p>

      <Field
        name="notifyOnSecureLinkAccess"
        type="checkbox"
        component={CheckboxField}
        label={t('notifyWhenSubmitsSL')}
      />

      <Field
        name="notifyOnWaitingRoomEntry"
        type="checkbox"
        component={CheckboxField}
        label={t('notifyWhenEntersWaitingRoom')}
      />
    </div>
  );
};

export default ShareableLinkNotifications;
